/**
 * お客様の声（商品ページ）。
 *
 * データ元は Cloudflare Workers + D1。
 *   GET  /v1/summary          商品ハンドルごとの件数・平均・星の内訳
 *   GET  /v1/reviews?limit=&offset=&sort=&stars=   公開済み一覧（handleを付けなければ全商品）
 *   POST /v1/reviews          投稿（承認待ちに入る）
 *
 * 守ること:
 *   - 取得に失敗したら枠ごと出さない。口コミのために購入導線を止めない
 *   - 範囲は data-scope で決まる（2026-09-03・クライアント要望）。
 *       product … その商品の口コミだけ。一覧は handle 付きで取り、総合評価もその商品のみ
 *       all     … 全商品の口コミ。一覧は handle なし、総合評価は全ハンドルの合算
 *     既定は product。全商品表示に戻すときはテーマ設定「口コミの範囲」を変える
 */
(function () {
  var root = document.querySelector('[data-sk-rv]');
  if (!root) return;

  /* 文言は layout/theme.liquid の window.Sekka（locales由来）から。取れなければ英語の素の値 */
  var T = (window.Sekka && window.Sekka.t) || {};

  var API = root.dataset.endpoint;
  var HANDLE = root.dataset.handle || '';
  /* 商品ハンドルが取れない場合（テーマエディタのプレビュー等）は全商品に落とす */
  var SCOPE = root.dataset.scope === 'all' || !HANDLE ? 'all' : 'product';
  var PAGE = parseInt(root.dataset.pageSize, 10) || 10;

  var elAvg = root.querySelector('[data-sk-rv-avg]');
  var elStars = root.querySelector('[data-sk-rv-stars]');
  var elCount = root.querySelector('[data-sk-rv-count]');
  var elDist = root.querySelector('[data-sk-rv-dist]');
  var elList = root.querySelector('[data-sk-rv-list]');
  var elMore = root.querySelector('[data-sk-rv-more]');
  var elForm = root.querySelector('[data-sk-rv-form]');
  var elMsg = root.querySelector('[data-sk-rv-msg]');

  var offset = 0;
  var total = 0;
  // 星ごとの件数（[★1, ★2, ★3, ★4, ★5]）。絞り込み後の総数をここから出す
  var DIST = [0, 0, 0, 0, 0];

  // 並び替えと星の絞り込み（クライアント要望・2026-10-04）。sort: 'new' | 'rating' / stars: [5, 4] など
  var filter = { sort: 'new', stars: [] };
  var elState = root.querySelector('[data-sk-rv-state]');
  var elSheet = root.querySelector('[data-sk-rv-sheet]');
  var elFilter = root.querySelector('[data-sk-rv-filter]');
  var elNoMatch = root.querySelector('[data-sk-rv-nomatch]');

  // 投稿時に添える商品名。今開いている商品ページのもの
  var TITLE = root.dataset.title || '';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /** 星を5つ描く。半端は0.5刻みで塗り幅を変える（4.3なら4つ目まで満、5つ目は3割） */
  function stars(v) {
    var out = '';
    for (var i = 1; i <= 5; i++) {
      var pct = Math.max(0, Math.min(1, v - (i - 1))) * 100;
      out +=
        '<span class="sk-rv__star">' +
        '<span class="sk-rv__star-on" style="width:' + pct + '%"></span>' +
        '</span>';
    }
    return out;
  }

  /** YYYY-MM-DD を locales の書式（sekka.date.numeric_ymd）に流し込む。
      年月日の並びは言語で変わるので [y] [m] [d] の差し込みにしてある（2026-08-10） */
  function fmtDate(s) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s || '');
    if (!m) return '';
    return (T.reviews_date || '[y]-[m]-[d]')
      .replace('[y]', m[1])
      .replace('[m]', String(Number(m[2])))
      .replace('[d]', String(Number(m[3])));
  }

  function renderSummary(sum) {
    // APIは商品ハンドルごとに返す。
    // product … 自分のハンドルの行だけ見る／all … 全ハンドルを1つにまとめる
    var count = 0;
    var sumRating = 0;
    var dist = [0, 0, 0, 0, 0];
    Object.keys(sum || {}).forEach(function (h) {
      if (SCOPE === 'product' && h !== HANDLE) return;
      var s = sum[h];
      count += s.count;
      sumRating += s.avg * s.count;
      for (var i = 0; i < 5; i++) dist[i] += s.dist[i] || 0;
    });
    if (!count) return 0;
    DIST = dist;

    var avg = sumRating / count;
    // 総合評価は小数2桁（ebine参考・2026-09-23）。価格横の小さい表示は1桁
    elAvg.textContent = (Math.round(avg * 100) / 100).toFixed(2);
    elStars.innerHTML = stars(avg);
    var elPeople = root.querySelector('[data-sk-rv-people]');
    if (elPeople && T.reviews_people_count) {
      elPeople.textContent = T.reviews_people_count.replace('[count]', count);
    } else {
      elCount.textContent = count;
    }
    renderInline(avg, count);

    // 5→1の順。参考画像と同じく「★5 ─── 133件」の並び
    var rows = '';
    for (var n = 5; n >= 1; n--) {
      var c = dist[n - 1] || 0;
      var pct = count ? Math.round((c / count) * 100) : 0;
      rows +=
        '<li class="sk-rv__dist-row">' +
        '<span class="sk-rv__dist-label">' +
        '<span class="sk-rv__star sk-rv__star--solid"></span>' + n +
        '</span>' +
        '<span class="sk-rv__dist-bar"><span style="width:' + pct + '%"></span></span>' +
        '<span class="sk-rv__dist-num">' + c + esc(T.reviews_people_suffix != null ? T.reviews_people_suffix : (T.reviews_count_suffix || '')) + '</span>' +
        '</li>';
    }
    elDist.innerHTML = rows;
    return count;
  }

  /** 価格の横の「★★★★★ 4.8 (6件)」（クライアント要望・2026-09-23 / ebine参考）。
      口コミ0件・取得失敗のときは hidden のまま＝何も出さない */
  function renderInline(avg, count) {
    document.querySelectorAll('[data-sk-rv-inline]').forEach(function (el) {
      var st = el.querySelector('[data-sk-rv-inline-stars]');
      var av = el.querySelector('[data-sk-rv-inline-avg]');
      var ct = el.querySelector('[data-sk-rv-inline-count]');
      if (st) st.innerHTML = stars(avg);
      if (av) av.textContent = (Math.round(avg * 10) / 10).toFixed(1);
      if (ct) ct.textContent = count;
      el.hidden = false;
    });
  }

  function renderRows(rows) {
    var html = '';
    rows.forEach(function (r) {
      // どの商品へのレビューかを出す。全商品表示のときだけ意味があるので
      // その商品だけの表示（SCOPE=product）では出さない（全行が同じ名前になるため）
      var product = SCOPE === 'all' && r.p
        ? '<a class="sk-rv__item-product" href="/products/' + encodeURIComponent(r.h) + '">' +
          esc(r.p) + '</a>'
        : '';

      html +=
        '<li class="sk-rv__item">' +
        '<div class="sk-rv__item-head">' +
        '<span class="sk-rv__item-rate">' +
        '<span class="sk-rv__stars sk-rv__stars--sm" aria-label="' +
        esc((T.reviews_star_n || '[count]').replace('[count]', r.r)) + '">' + stars(r.r) + '</span>' +
        // 星の横に点数（クライアント要望・2026-09-23）
        '<span class="sk-rv__item-score" aria-hidden="true">' + esc(r.r) + '</span>' +
        '</span>' +
        '<span class="sk-rv__date">' + fmtDate(r.d) + '</span>' +
        '</div>' +
        product +
        // バリエーション（カラー等）。BASEから引き継いだものが入っている
        (r.g ? '<p class="sk-rv__item-variant">' + esc(r.g) + '</p>' : '') +
        (r.t ? '<p class="sk-rv__item-title">' + esc(r.t) + '</p>' : '') +
        '<p class="sk-rv__item-body">' + esc(r.b) + '</p>' +
        // ショップからの返信（クライアント要望・2026-10-04 / ebine参考）。承認画面 /admin で書く
        (r.rp
          ? '<div class="sk-rv__reply">' +
            '<p class="sk-rv__reply-head"><span>' + esc(T.reviews_reply_heading || 'Reply from the shop') + '</span>' +
            '<span class="sk-rv__date">' + fmtDate(r.ra) + '</span></p>' +
            '<p class="sk-rv__reply-body">' + esc(r.rp) + '</p>' +
            '</div>'
          : '') +
        '</li>';
    });
    elList.insertAdjacentHTML('beforeend', html);
  }

  function loadPage() {
    var q = '/v1/reviews?limit=' + PAGE + '&offset=' + offset;
    if (SCOPE === 'product') q += '&handle=' + encodeURIComponent(HANDLE);
    if (filter.sort === 'rating') q += '&sort=rating';
    if (filter.stars.length) q += '&stars=' + filter.stars.join(',');
    return fetch(API + q, { credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('reviews ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var rows = (data && data.reviews) || [];
        renderRows(rows);
        offset += rows.length;
        // 総件数に届いたら、または返りが0件ならボタンを畳む
        elMore.hidden = rows.length === 0 || offset >= total;
      });
  }

  // 初期表示。サマリーが0件なら枠ごと出さない（空の「お客様の声」を見せない）
  fetch(API + '/v1/summary', { credentials: 'omit' })
    .then(function (res) {
      if (!res.ok) throw new Error('summary ' + res.status);
      return res.json();
    })
    .then(function (data) {
      total = renderSummary(data && data.summary);
      if (!total) {
        // 0件の商品でも「レビューを書く」ボタンだけは出す（クライアント要望・2026-09-28）。
        // 総合評価・一覧は空なので伏せる。フォームを消す設定のときは従来どおり枠ごと出さない
        if (elForm) {
          root.classList.add('is-empty');
          root.hidden = false;
        }
        return;
      }
      root.hidden = false;
      return loadPage();
    })
    .catch(function () {
      // 失敗しても何も出さない。エラー文言も出さない
      root.hidden = true;
    });

  /** 絞り込み後の件数。星の指定が無ければ全件 */
  function filteredTotal() {
    if (!filter.stars.length) return DIST.reduce(function (a, b) { return a + b; }, 0);
    return filter.stars.reduce(function (a, n) { return a + (DIST[n - 1] || 0); }, 0);
  }

  /** ボタン横の「新しい順・★5 ★4」 */
  function renderState() {
    if (!elState) return;
    var txt = filter.sort === 'rating' ? (T.reviews_sort_rating || 'Highest rated') : (T.reviews_sort_new || 'Newest');
    if (filter.stars.length) {
      txt += ' ・ ' + filter.stars.slice().sort().reverse().map(function (n) { return '★' + n; }).join(' ');
    }
    elState.textContent = txt;
  }

  function applyFilter() {
    total = filteredTotal();
    offset = 0;
    elList.innerHTML = '';
    elMore.hidden = true;
    renderState();
    if (elNoMatch) elNoMatch.hidden = total > 0;
    if (!total) return;
    loadPage().catch(function () {});
  }

  function openSheet() {
    if (!elSheet) return;
    // 開くたびに今の条件をフォームへ戻す（適用せずに閉じた変更は捨てる）
    elFilter.querySelectorAll('input[name="sort"]').forEach(function (i) { i.checked = i.value === filter.sort; });
    elFilter.querySelectorAll('input[name="stars"]').forEach(function (i) { i.checked = filter.stars.indexOf(+i.value) !== -1; });
    elSheet.hidden = false;
    document.documentElement.classList.add('sk-rv-lock');
    var first = elSheet.querySelector('.sk-rv__sheet-x');
    if (first) first.focus();
  }
  function closeSheet() {
    if (!elSheet || elSheet.hidden) return;
    elSheet.hidden = true;
    document.documentElement.classList.remove('sk-rv-lock');
    var opener = root.querySelector('[data-sk-rv-filter-open]');
    if (opener) opener.focus();
  }

  if (elSheet && elFilter) {
    root.querySelector('[data-sk-rv-filter-open]').addEventListener('click', openSheet);
    elSheet.querySelectorAll('[data-sk-rv-close]').forEach(function (b) { b.addEventListener('click', closeSheet); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
    root.querySelector('[data-sk-rv-clear]').addEventListener('click', function () {
      elFilter.querySelector('input[name="sort"][value="new"]').checked = true;
      elFilter.querySelectorAll('input[name="stars"]').forEach(function (i) { i.checked = false; });
    });
    elFilter.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var fd = new FormData(elFilter);
      filter.sort = fd.get('sort') === 'rating' ? 'rating' : 'new';
      filter.stars = fd.getAll('stars').map(Number).filter(function (n) { return n >= 1 && n <= 5; });
      closeSheet();
      applyFilter();
    });
  }

  if (elMore) {
    elMore.addEventListener('click', function () {
      elMore.disabled = true;
      loadPage().finally(function () {
        elMore.disabled = false;
      });
    });
  }

  // ---- 投稿 ----
  if (elForm) {
    elForm.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var fd = new FormData(elForm);
      var body = String(fd.get('body') || '').trim();

      if (body.length < 10) {
        elMsg.textContent = T.reviews_too_short || 'Please write at least 10 characters.';
        elMsg.className = 'sk-rv__msg is-ng';
        return;
      }

      var btn = elForm.querySelector('.sk-rv__submit');
      btn.disabled = true;
      elMsg.textContent = T.reviews_sending || 'Sending…';
      elMsg.className = 'sk-rv__msg';

      fetch(API + '/v1/reviews', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'omit',
        body: JSON.stringify({
          product_handle: HANDLE,
          product_title: TITLE,
          rating: Number(fd.get('rating') || 5),
          body: body,
          author_name: String(fd.get('author_name') || '').trim() || T.reviews_anonymous || 'Anonymous',
        }),
      })
        .then(function (res) {
          return res.json().then(function (d) {
            return { ok: res.ok, d: d };
          });
        })
        .then(function (r) {
          if (!r.ok) throw new Error((r.d && r.d.error) || T.reviews_failed || 'Sending failed');
          elForm.reset();
          elMsg.textContent = T.reviews_thanks || 'Thank you. Your review will appear once we have checked it.';
          elMsg.className = 'sk-rv__msg is-ok';
        })
        .catch(function (e) {
          elMsg.textContent = String(e.message || T.reviews_failed || 'Sending failed');
          elMsg.className = 'sk-rv__msg is-ng';
        })
        .finally(function () {
          btn.disabled = false;
        });
    });
  }
})();
